import { createSlice } from '@reduxjs/toolkit';
const notifShowSlice = createSlice({
  name: 'notifShow',
  initialState: [],
  //NOTE filtersTYPE=[ {checkMode:"all",filtersMode:[ {column:"HI" , mode: "contains" , value: "helloworld"},... ]} , ... ]
  reducers: {
    stopShowing: (state, action) => {
      state.push(action.payload);
      return state;
    }
  }
});
export const { stopShowing } = notifShowSlice.actions;
// export const NonFilterBacklink = gridDrawerSlice.getInitialState();
export default notifShowSlice;
